import React from "react";
import { DetailSidePanel } from "../DetailSidePanel";
import { SidePanelDeleteEntryButton } from "../SidePanelDeleteEntryButton";
import { emptyListFunc } from "components/MainSectionTemplate/emptySubmitChangeFunc";
import { AccessTypeSidePanelDetails } from "./AccessTypeSidePanelDetails";

interface AccessTypeSidePanelProps {
  list: server.dto.GuestlistList;
  trigger: JSX.Element
}

export const AccessTypeSidePanel = (props: AccessTypeSidePanelProps) => {
  return <DetailSidePanel
    apiCall={() => emptyListFunc()}
    apiKey="guestlistAccessType"
    entityId={props.list.guestlistAccessTypeId}
    title={RESX.Guestlist.List}
    trigger={props.trigger}
    footerContent={<>
      <SidePanelDeleteEntryButton
        apiCall={() => window.CoreApi.Guestlist.DeleteGuestlistAccessType({ guestlistAccessTypeId: props.list.guestlistAccessTypeId }, { toastOnError: true })}
      />
    </>}
  >
    {() => <AccessTypeSidePanelDetails list={props.list} />}
  </DetailSidePanel>;
};